export default __webpack_public_path__ + "static/media/icn-bac-failed.357547f9.svg";